import { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import _ from 'lodash'

import SearchInput from '../common/SearchInput'
import LoadingSpinner from '../common/loader/legacy-loaders/LoadingSpinner'

import classes from './CoachesHeader.module.scss'

const filterOptions = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'invited', label: 'Invited' },
  { value: 'inactive', label: 'Inactive' },
]

const DEBOUNCE_DURATION = 400

const CoachesHeader = ({
  coachCount,
  isSearching,
  statusFilter,
  onSearchChange,
  onFilterChange,
}) => {
  const debouncedSearch = useMemo(
    () => _.debounce((search) => { onSearchChange(search) }, DEBOUNCE_DURATION),
    [onSearchChange]
  )

  const handleSearchChange = (e) => {
    const term = e.target.value
    debouncedSearch(term)
  }

  return (
    <div className={classNames(classes.coachesHeader, 'w-100 d-flex justify-content-between align-items-center')}>
      <div className='d-flex align-items-center'>
        <h1 className={classNames(classes.coachesTitle, 'mr-3')}>Coaches ({coachCount})</h1>

        <SearchInput className={classes.searchInput} placeholder='Search for Coaches' onChange={handleSearchChange}/>
        {isSearching && <LoadingSpinner classNames={{ wrapper: classes.loading }} />}
      </div>

      <div className='d-flex align-items-center ml-auto'>
        {filterOptions.map(filter => (
          <button
            key={filter.value}
            className={classNames(classes.filterButton, { [classes.filterButtonActive]: statusFilter === filter.value }, 'ml-2')}
            onClick={() => onFilterChange(filter.value)}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  )
}

CoachesHeader.propTypes = {
  coachCount: PropTypes.number.isRequired,
  isSearching: PropTypes.bool.isRequired,
  statusFilter: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
}

export default CoachesHeader
